import React from "react";
import clsx from "clsx";
import {Label, Tooltip} from "flowbite-react";
import {SurveySectionsRenderingModel} from "data/models/survey/base";
import {QUESTION_CONTAINER_CLASS} from "components/Survey/classes";
import LoadingSurvey from "components/Survey/LoadingSurvey";
import {assertNoError} from "helpers/asserts";
import {useKeyMessages} from "data/access/survey-question-pages/key-messages";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";

const tooltipTheme = {
  "target": "w-full",
};

export default function ShowKeyMessageSurveyQuestionPage({businessName}: SurveySectionsRenderingModel) {
  const [keyMessages, keyMessagesLoading, keyMessagesError] = useKeyMessages();

  assertNoError(keyMessagesError);
  if (keyMessagesLoading) {
    return <LoadingSurvey/>;
  }

  if (isNullOrUndefined(keyMessages)) {
    return <></>;
  }

  const maxScore = Math.max(...keyMessages.map(km => km.score));

  return <div className={"flex flex-col w-full"}>
    <div className={clsx(QUESTION_CONTAINER_CLASS, "mb-24")}>
      <div>
        <p className={"my-8 font-normal text-xl text-neutral-500"}>
          To attract your ideal client, use messages that answer their questions
          and hook them emotionally. We will use these ideas to create a brand voice for {businessName}.
        </p>
      </div>
      <div>
        {keyMessages.slice(0, 3).map((keyMessage, index) => <div key={index}
                                                                 className="flex flex-col gap-2">
          <Label htmlFor={keyMessage.key}
                 className={"w-full inline-flex py-5 my-1 text-black peer-checked:border-bc-blue"}>
            <div className={"flex flex-col grow"}>
              <div className={"w-full"}>
                <span className={"text-xl font-normal"}>{keyMessage.name}</span>
              </div>
              <div className={"bg-bc-blue h-8"} style={{width: `${keyMessage.score / maxScore * 100}%`}}></div>
            </div>
          </Label>
        </div>)}
      </div>
      <div>
        <p className={"my-8 font-normal text-xl text-neutral-500"}>
          Your brand recommendations are ready!
          We have prepared fonts styles, color palettes, and brand voice guidance.
          These assets are customized for {businessName} are ready
          for you to use in Canva or other creative tools.
        </p>
      </div>
    </div>
  </div>
}
